/**
 * CrossFrame method name for tool error events.
 * Used by tools (sender) and ATBase (listener) to identify tool error messages.
 */
export const TOOL_ERROR_METHOD = 'toolError';

/**
 * Enum of supported tool error types.
 * Used as the `type` field in ToolErrorEvent to route errors to specific handlers.
 */
export enum ToolErrorType {
    SCAN_ERROR = 'scanError',
}

/**
 * Discriminated union for tool error events.
 * ATBase registers a single 'toolError' CrossFrameUtils listener that routes
 * by the `type` field to specific handlers (e.g., scanError → ScanErrorService).
 * Extensible for future error types by adding new union members.
 */
export type ToolErrorEvent = { type: ToolErrorType.SCAN_ERROR; payload: ScanErrorEvent };
// Extend with new union members, e.g.:
// | { type: ToolErrorType.NETWORK_ERROR; payload: NetworkErrorEvent }

/**
 * Scan error event payload published by CandyCane tools when a scan fails.
 * Tools emit this via CrossFrameUtils.sendMessageToOtherFrame() wrapped in a ToolErrorEvent.
 * SiteAI consumes this to classify the error and provide guided troubleshooting.
 *
 * @see LLD: https://quip-amazon.com/H6cFAlI4Y0uT
 */
export interface ScanErrorEvent {
    /** Tool identifier: "ordering", "cycle_count", "receiving", "shrink" */
    tool: string;
    /** Raw barcode value scanned by the TM */
    scanned_code: string;
    /** Current route/page name, e.g. "ProductDetailsPage", "ScanIdPage" */
    page: string;
    /** Raw backend error response/message */
    error_message: string;
    /** Raw backend error type: "NOT_FOUND", "DEPENDENCY_FAILURE", etc. */
    error_type: string;
    /** Any item details returned by backend (optional) */
    item_context?: object;
}
